module.exports = __webpack_public_path__ + "img/HaversianRemodeling_BoneSegment.8404f247.png";